import Vue from 'vue'
import Router from 'vue-router'
import BeautyList from '@/view/BeautyList'
import BeautyDetail from '@/view/BeautyDetail'
import Login from '@/view/Login'
import Regis from '@/view/Register'
import Upload from '@/view/Upload'
import vip from '@/view/vip'
import canNotUse from '@/view/canNotUse'


Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/DeliDe',
            name: 'DeliciousDetail',
            component: resolve => require(['@/view/DeliciousDetail'], resolve),
            meta: {
                keepAlive: false,    //设置keepAlive为true,则App.vue里的$route.meta.keepAlive即为true
            }
        }
        ,
        {
            path: '/',
            name: 'index',
            component: resolve => require(['@/view/DeliciousList'], resolve),
            meta: {
                keepAlive: true,
            }
        },
        {
            path: '/delicious',
            name: 'DeliciousList_OLD',
            component: resolve => require(['@/view/DeliciousList'], resolve),
            meta: {
                keepAlive: true,
            }
        },
        {
            path: '/meishi',
            name: 'DeliciousList',
            component: resolve => require(['@/view/DeliciousList'], resolve),
            meta: {
                keepAlive: true,
            }
        },
        {
            path: '/ButyDe',
            name: 'BeautyDetail',
            component: resolve => require(['@/view/BeautyDetail'], resolve),
            meta: {
                keepAlive: false,
            }
        },
        {
            path: '/beauty',
            name: 'BeautyList_OLD',
            component: resolve => require(['@/view/BeautyList'], resolve),
            meta: {
                keepAlive: true,
            }
        },
        {
            path: '/meizhuang',
            name: 'BeautyList',
            component: resolve => require(['@/view/BeautyList'], resolve),
            meta: {
                keepAlive: true,
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: resolve => require(['@/view/Login'], resolve),
            meta: {
                keepAlive: true,
            }
        },
        {
            path: '/Regis',
            name: 'Regis',
            component: resolve => require(['@/view/Register'], resolve),
            meta: {
                keepAlive: true,
            }
        },
        {
            path: '/Ulod',
            name: 'Upload',
            component: resolve => require(['@/view/Upload'], resolve),
            meta: {
                keepAlive: true,
            }
        },
        {
            path: '/Tov',
            name: 'Rede',
            component: resolve => require(['@/view/Redet'], resolve),
            meta: {
                keepAlive: false,
            }
        },
        {
            path: '/Tovp',
            name: 'vip',
            component: resolve => require(['@/view/vip'], resolve),
            meta: {
                keepAlive: false,
            }
        },
        {
            path: '/cntjs',
            name: 'cantuse',
            component: resolve => require(['@/view/canNotUse'], resolve),
            meta: {
                keepAlive: false,
            }
        }, {
            path: '/privacy',
            name: 'privacy',
            component: resolve => require(['@/view/privacy'], resolve),
            meta: {
                keepAlive: false,
            }
        }, {
            path: '/userAgree',
            name: 'userAgreement',
            component: resolve => require(['@/view/userAgreement'], resolve),
            meta: {
                keepAlive: false,
            }
        },
        {
            path: '/honor/meishi',
            name: 'HonorDeliciousList',
            component: resolve => require(['@/view/honor/DeliciousList'], resolve),
            meta: {
                keepAlive: true,
            }
        },
        {
            path: '/honor/meishi/DeliDe',
            name: 'HonorDeliDe',
            component: resolve => require(['@/view/honor/DeliciousDetail'], resolve),
            meta: {
                keepAlive: false,
            }
        },
        {
            path: '/honor/meizhuang',
            name: 'HonorBeautyList',
            component: resolve => require(['@/view/honor/BeautyList'], resolve),
            meta: {
                keepAlive: true,
            }
        },
        {
            path: '/honor/meizhuang/ButyDe',
            name: 'HonorButyDe',
            component: resolve => require(['@/view/honor/BeautyDetail'], resolve),
            meta: {
                keepAlive: false,
            }
        },
        {
            path: '/alternate/meishi',
            name: 'AlterDeliciousList',
            component: resolve => require(['@/view/alternate/DeliciousList'], resolve),
            meta: {
                keepAlive: true,
            }
        },
        {
            path: '/alternate/meishi/DeliDe',
            name: 'AlterDeliDe',
            component: resolve => require(['@/view/alternate/DeliciousDetail'], resolve),
            meta: {
                keepAlive: false,
            }
        },
        {
            path: '/alternate/meizhuang',
            name: 'AlterBeautyList',
            component: resolve => require(['@/view/alternate/BeautyList'], resolve),
            meta: {
                keepAlive: true,
            }
        },
        {
            path: '/alternate/meizhuang/ButyDe',
            name: 'AlterButyDe',
            component: resolve => require(['@/view/alternate/BeautyDetail'], resolve),
            meta: {
                keepAlive: false,
            }
        }, {
            path: '/userAgreeForBiz',
            name: 'userAgreeForBiz',
            component: resolve => require(['@/view/userAgreementForBiz'], resolve),
            meta: {
                keepAlive: false,
            }
        }, {
            path: '/privacyForBiz',
            name: 'privacyForBiz',
            component: resolve => require(['@/view/privacyForBiz'], resolve),
            meta: {
                keepAlive: false,
            }
        },
        {
            path: '/1071/meishi',
            name: 'HuaweiDeliciousList',
            component: resolve => require(['@/view/1071/DeliciousList'], resolve),
            meta: {
                keepAlive: true,
            }
        },
        {
            path: '/1071/meishi/DeliDe',
            name: 'HuaweiDeliDe',
            component: resolve => require(['@/view/1071/DeliciousDetail'], resolve),
            meta: {
                keepAlive: false,
            }
        },
        {
            path: '/1071/meizhuang',
            name: 'HuaweiBeautyList',
            component: resolve => require(['@/view/1071/BeautyList'], resolve),
            meta: {
                keepAlive: true,
            }
        },
        {
            path: '/1071/meizhuang/ButyDe',
            name: 'HuaweiButyDe',
            component: resolve => require(['@/view/1071/BeautyDetail'], resolve),
            meta: {
                keepAlive: false,
            }
        },
        {
            path: '/1069/meishi',
            name: 'SumSungDeliciousList',
            component: resolve => require(['@/view/sumsung/DeliciousList'], resolve),
            meta: {
                keepAlive: true,
            }
        },
        {
            path: '/1069/meishi/DeliDe',
            name: 'SumSungDeliDe',
            component: resolve => require(['@/view/sumsung/DeliciousDetail'], resolve),
            meta: {
                keepAlive: false,
            }
        },
        {
            path: '/1069/meizhuang',
            name: 'SumSungBeautyList',
            component: resolve => require(['@/view/sumsung/BeautyList'], resolve),
            meta: {
                keepAlive: true,
            }
        },
        {
            path: '/1069/meizhuang/ButyDe',
            name: 'SumSungButyDe',
            component: resolve => require(['@/view/sumsung/BeautyDetail'], resolve),
            meta: {
                keepAlive: false,
            }
        },
        {
            path: '/:from/jiaju',
            name: 'ChannelRenoList',
            component: resolve => require(['@/view/RenoList'], resolve),
            meta: {
                keepAlive: true,
            }
        },
        {
            path: '/:from/reno_detail',
            name: 'ChannelRenoDetail',
            component: resolve => require(['@/view/RenoDetail'], resolve),
            meta: {
                keepAlive: false,
            }
        },
        {
            path: '/jiaju',
            name: 'RenoList',
            component: resolve => require(['@/view/RenoList'], resolve),
            meta: {
                keepAlive: true,
            }
        },
        {
            path: '/reno_detail',
            name: 'RenoDetail',
            component: resolve => require(['@/view/RenoDetail'], resolve),
            meta: {
                keepAlive: false,
            }
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js